/**
 * How a service cycle is named to a person (1.5.13 §1c.6): by its month — "October 2026" — never by its code.
 * The code (HK-202610) stays where it identifies something: the address (?cycle=), exports and the audit log. It
 * is never in a page title or on a card — nor, since 1.5.16, in the Cycle dropdown: its options are months too.
 */
import { formatMonthYear } from '@/lib/dates';

/** "HK-202610" → "October 2026". A code that is not HK-yyyyMM is left as written. */
export function cycleMonthLabel(code: string, lang: string): string {
  const m = /^HK-(\d{4})(0[1-9]|1[0-2])$/.exec(code);
  return m ? formatMonthYear(`${m[1]}${m[2]}01`, lang) : code;
}

/** An option of the Cycle dropdown (1.5.16): the month the cycle starts in — "October 2026", "octubre de 2026". */
export function cycleOptionLabel(cycle: { code: string; startKey: string }, lang: string): string {
  return formatMonthYear(cycle.startKey, lang);
}

/** The month without its year, as Planning's buttons name it: "October", "octubre". */
export function monthWord(startKey: string, lang: string): string {
  return formatMonthYear(startKey, lang).split(' ')[0] ?? '';
}

/** Planning's title: the month the cycle starts in, and nothing else. */
export function planningTitle(cycle: { code: string; startKey: string }, lang: string): string {
  return formatMonthYear(cycle.startKey, lang);
}
